export const chartEventIconsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "chart-event-icons" */ './chart-event-icons-module-entry'),
  cacheKey: 'chart-event-icons',
}

export const chartAlertIconsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "chart-alert-icons" */ './chart-alert-icons-module-entry'),
  cacheKey: 'chart-alert-icons',
}
